// InfoNieuw.js - Updated loading state
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ResidentSidebar from '../components/ResidentSidebar';
import EditablePage from '../components/EditablePage';
import { getPageContent, savePageContent } from '../components/pageContentService';
import '../css/Basispagina.css';

const InfoNieuw = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'nl');
  const [pageContent, setPageContent] = useState({
    title: 'Welkom in Polderzicht', // Default title
    titleEn: 'Welcome to Polderzicht', // Default English title
    bodyHtml: '<p>Geen content beschikbaar.</p>', // Default content
    bodyHtmlEn: '<p>No content available.</p>' // Default English content
  });
  const [loading, setLoading] = useState(true);
  const isAuthenticated = !!localStorage.getItem('token');

  // Load page content
  useEffect(() => {
    const loadPageContent = async () => {
      try {
        let longLoadingTimeout = setTimeout(() => {
          setLoading(true);
        }, 1);
     
        const content = await getPageContent('infonieuw');
        console.log("Loaded content:", content); // Debug

        clearTimeout(longLoadingTimeout);
        
        // Update state with retrieved content, keeping defaults for empty values
        setPageContent({
          title: content.title || 'Welkom in Polderzicht',
          titleEn: content.titleEn || 'Welcome to Polderzicht',
          bodyHtml: content.bodyHtml || '<p>Geen content beschikbaar.</p>',
          bodyHtmlEn: content.bodyHtmlEn || '<p>No content available.</p>'
        });
        setLoading(false);
      } catch (error) {
        console.error('Error loading page content:', error);
        setLoading(false);
      }
    };

    loadPageContent();
  }, []);

  // Effect to update when language changes
  useEffect(() => {
    // Update localStorage when language changes
    localStorage.setItem('language', language);
  }, [language]);

  // Get title based on language
  const getTitle = () => {
    if (language === 'en' && pageContent.titleEn) {
      return pageContent.titleEn;
    }
    return pageContent.title || 'Welkom in Polderzicht';
  };

  // Get content based on language
  const getBodyHtml = () => {
    if (language === 'en' && pageContent.bodyHtmlEn) {
      return pageContent.bodyHtmlEn;
    }
    return pageContent.bodyHtml || '<p>Geen content beschikbaar.</p>';
  };

  // Handle saving
const handleSaveContent = async (updatedContent) => {
  try {
    console.log("Saving InfoNieuw content:", updatedContent);
    
    // Save to both state and backend
    setPageContent(updatedContent);
    
    // Also save to localStorage as immediate backup
    localStorage.setItem(`vve_infonieuw_cache`, JSON.stringify(updatedContent));
    
    const success = await savePageContent('infonieuw', updatedContent);
    
    if (success) {
      alert('Content saved successfully!');
    } else {
      alert('Content saved locally. Changes will be visible but not synced to server.');
    }
  } catch (error) {
    console.error('Error saving page content:', error);
    alert('Error saving content to server, but content is saved locally.');
  }
};

  // UPDATED LOADING STATE - Keep sidebar and layout visible during loading
  if (loading) {
    return (
      <div className="page-with-sidebar">
        <ResidentSidebar language={language} setLanguage={setLanguage} />
        
        <div className="main-content info-page-content" style={{ backgroundColor: '#f8fff4' }}>
          <div className="info-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
     
          </div>
          
          <footer className="page-footer">
            <p>&copy; {new Date().getFullYear()} VVE Polderzicht • <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <div className="page-with-sidebar">
      <ResidentSidebar language={language} setLanguage={setLanguage} />
      
      <div className="main-content info-page-content">
        <div className="info-container">
          {/* Editable page component */}
          <EditablePage
            pageType="infonieuw"
            content={pageContent}
            onSave={handleSaveContent}
            language={language}
            isAuthenticated={isAuthenticated}
          />
          
          {/* Render the actual content */}
          <h1>{getTitle()}</h1>
          
          <div 
            className="page-content"
            dangerouslySetInnerHTML={{ __html: getBodyHtml() }} 
          />
        </div>
        
        <footer className="page-footer">
          <p>&copy; {new Date().getFullYear()} VVE Polderzicht • <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
        </footer>
      </div>
    </div>
  );
};

export default InfoNieuw;